<template>
	<div class="benefit">
		<div class="head">
			<div class="select_year">
				<span class="label">选择年份:</span>
				<el-date-picker v-model="year" type="year" format="yyyy" size="mini" value-format="yyyy"
					placeholder="选择年" @change="changeYear" :picker-options="pickerOptions">
				</el-date-picker>
			</div>
			<div class="tabs">
				<span v-for="(item,index) in tabsList" :class="{'active':tabShowNum==index}"
					@click="tabsClick(index)">{{item}}</span>
			</div>
		</div>
		<div class="wx_content" v-if="tabShowNum==0">
			<div class="echars_warp">
				<div class="pie">
					<div class="wx_box">
						<div class="wx_main">
							<div class="top">

								<div class="wx_progress">
									<div class="item">
										<span class="label">预计总投入：</span>
										<span class="progress">
											<i class="violet" :style="{'width':estimateWidth+'%'}"></i>
										</span>
										<i class="val">{{est_total}}万元</i>
									</div>
									<div class="item">
										<span class="label">实际总投入：</span>
										<span class="progress">
											<i class="pink" :style="{'width':actualWidth+'%'}"></i>
										</span>
										<i class="val">{{fact_total}} (截止今日)</i>
									</div>
								</div>
							</div>
							<div class="echarts_box">
								<wxPie :pieData="pieData1" v-if="show"></wxPie>
								<wxPie :pieData="pieData2" v-if="show"></wxPie>
							</div>
						</div>
					</div>
				</div>
				<div class="bar">
					<div class="wx_box">
						<div class="wx_main">
							<div class="top">

							</div>
							<div class="echarts_box">
								<wxColumnar :seriesData="columnarData1" v-if="show"></wxColumnar>
								<table class="bar_table">
									<tbody>
										<tr>
											<td>预计投入</td>
											<td v-for="(item,index) in pieData1.pieEchartsData" v-if="index!=3">
												{{item.value}}</td>

										</tr>
										<tr>
											<td class="actualTd">实际投入</td>
										<!-- 	<td v-for="(item,index) in pieData2.pieEchartsData" v-if="index!=2">
												{{item.value}}<span @click="clickFeeType(index)">(详情)</span></td> -->
												<td v-for="(item,index) in fact_data" v-if="index!=2">
														{{item.value}}<span @click="clickFeeType(index)">(详情)</span></td>

										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<WxMessageBox :show="feeShow" @save="feeSave" @canse="feeCanse" :width="width">
				<div slot="content">
					<div class="tableBox">
						<div class="top">
							<div class="wx_title">
								<span>{{title}}</span>
							</div>
							<span class="closse" @click="feeShow = false">关闭</span>
						</div>
						<el-table :data="tableData" class="wx_table" :row-class-name="tableRowClassName" key="tab1">
							<el-table-column :prop="item.prop" :label="item.label" min-width="120"
								v-for="(item,index) in fields" :key="'td'+index"></el-table-column>

						</el-table>
						<div class="pagination" v-if="index<4">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="tabPage.currentPage" :page-sizes="[10, 20, 30, 40]"
								:page-size="tabPage.pagesize" :total="total"></el-pagination>
						</div>
					</div>
				</div>
			</WxMessageBox>
		</div>
		<div class="wx_content" v-if="tabShowNum==1">
			<div class="wx_box">
				<div class="wx_main">
					<div class="top">
						<div class="wx_title">
							<span>生产效益</span>
						</div>
					</div>
					<div class="wx_bar">
						<div class="echarts_bar fl">
							<NewColumnar :seriesData="columnarData2" :barWidth="barWidth" :height="barheight"
								:barCategoryGap="barCategoryGap" :barGap="barGap" key="1" v-if="show1"></NewColumnar>
						</div>
						<div class="tabs_bar fl">
							<table class="bar_table">
								<thead>
									<tr>
										<th width="140">品种</th>
										<th width="140">预估产量(斤)</th>
										<th width="150">实际产量(斤)</th>
										<th width="140">预估价值(元)</th>
										<th width="140">实际产值(元)</th>
										<th width="140">单株产量(斤/株)</th>

									</tr>
								</thead>
								<tbody>
									<tr v-for="(item,index) in income_list " :key="'list'+index">
										<td>{{item.crop.name}}</td>
										<td>{{item.yjtotal_number}}</td>
										<td>{{item.sjtotal_number}}</td>
										<td>{{item.yjtotal_price}}</td>
										<td>{{item.sjtotal_price}}</td>
										<td>{{item.dztotal_price}}</td>
									</tr>
									<tr>
										<td>合计</td>
										<td colspan="2">产值: {{income_list.length}}个品种</td>
										<td colspan="3">总产量:{{total}}(斤)</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="wx_content" v-if="tabShowNum==2">
			<div class="wx_box">
				<div class="wx_main">
					<div class="top">

						<div class="wx_progress">
							<div class="item">
								<span class="label">预计产投比：</span>
								<span class="progress">
									<i class="violet" :style="{'width':estimateWidth+'%'}"></i>
								</span>
								<i class="val">{{est_rate}}:1</i>
							</div>
							<div class="item">
								<span class="label">实际产投比：</span>
								<span class="progress">
									<i class="pink" :style="{'width':actualWidth+'%'}"></i>
								</span>
								<i class="val">{{fact_rate}}:1</i>
							</div>
						</div>
					</div>
					<div class="wx_bar">
						<div class="w800">
							<Columnar :seriesData="columnarData3" :barWidth="barWidth2" :height="barheight"
								:barCategoryGap="barCategoryGap" :barGap="barGap" key="2" v-if="show2"></Columnar>
						</div>

						<div class="w800">
							<Columnar :seriesData="columnarData4" :height="barheight" key="4" v-if="show2"></Columnar>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import WxMessageBox from '@/components/MessageBox';
	import {
		getFarmInvest,
		getFarmFeeList,
		getFarmIncome,
		getFarmProfit
	} from '@/api/benefit'
	import wxPie from '@/components/PieEcharts.vue';
	import wxColumnar from '@/components/ColumnarContrast.vue';
	import Columnar from '@/components/Columnar.vue';
	import NewColumnar from '@/components/NewColumnar.vue';
	import {
		getFarmInfo
	} from '@/api/api'
	export default {
		name: "benefit",
		data() {
			return {

				tabShowNum: 0,
				tabsList: ['总投入', '总收入', '生产效益'],
				year: new Date().getFullYear().toString(),
				pickerOptions: this.disabledDate(),
				farm_reg_year: "",
				show: false,
				feeShow: false,
				show1: false,
				show2: false,
				index: 0,
				total: 0,
				fields: [],
				title: '',
				width: '1460px',
				tabPage: {
					currentPage: 1, // 初始页
					pagesize: 5, // 每页的数据
				},

				// year:2021,
				estimateWidth: '100',
				actualWidth: '100',
				//预计投入
				est_total: 0,
				fact_total: 0,
                fact_data:[],  

				pieData1: {
					title: '预计总投入(单位:万元)',
					subTitle: '',
					seriesName: '预计总投入(单位:万元)',
					pieEchartsData: []
				},
				pieData2: {
					title: '实际总投入(单位:万元)',
					subTitle: '',
					seriesName: '土地租金(单位:万元)',
					pieEchartsData: []
				},
				columnarData1: {
					title: '各费用对比',
					yAxisName: '单位:万元',
					xAxisData: [],
					estimateData: [],
					actualData: [],

				},
				tableData: [],



				income_list: [],
				total: 0,
				est_rate: 1,
			 fact_rate: 1,
				columnarData2: {
					title: '产值',
					yAxisName: '单位：？',
					xAxisData: ['预估产值', '实际产值'],

					actualData: [],

				},
				barCategoryGap: '20%',
				barGap: '20%',
				barWidth: '150',
				barWidth2: '140',
				barheight: '436px',
				columnarData3: {
					title: '生产效益',
					yAxisName: '单位：？',
					xAxisData: [],
					estimateData: [],
					actualData: [],
					legendData: ['预计生产效益(万元)', '实际生产效益 (万元)截止今日'],
					seriesName: ['预计产效益(万元)', '实际产效益 (万元)截止今日']
				},
				columnarData4: {
					title: '历史实际生产效益',
					yAxisName: '单位：？',
					xAxisData: [],
					estimateData: [],
					actualData: [],
					legendData: ['预计总产值(万元)', '实际总产值 (万元)截止今日'],
					seriesName: ['预计总产值(万元)', '实际总产值 (万元)截止今日']
				},

			}
		},
		created() {

			getFarmInfo(this.$route.params.id).then(resp => {


				if (resp.farm.is_check == 1) {
					this.get_farm_invest()
				} else {
					this.$message.error("请先完善农事管理板块相关申请工作，才能开通此板块！")
					this.$router.push("/park/detail/" + this.$route.params.id)
				}
			})

		},
		methods: {
			disabledDate() {
				let that = this
				console.log(that.year_list)
				return {
					disabledDate(date) {
						let result=true
						if(that.farm_reg_year>=date.getFullYear())
						{
					    result=false
						}else{
						
						}
						return result						
					}
				}
			},
			clickFeeType(index) {

				this.index = index
				this.get_farm_fee_list()
			},

			changeYear(year) {
				this.show=false
				this.year = year
				this.tabShowNum = 0
				this.fact_data=[]
		
				this.columnarData1["title"]='各费用对比',
				this.columnarData1["yAxisName"]='单位:万元',
				this.columnarData1["xAxisData"]=[],
				this.columnarData1["estimateData"]=[],
				
				this.columnarData1["actualData"]=[],
			
				this.get_farm_invest()
			},
			get_farm_fee_list() {
				getFarmFeeList(this.$route.params.id, this.year, this.index, this.tabPage).then(resp => {
					this.feeShow = true
					this.tableData = resp.list
					this.total = resp.total
					this.fields = resp.fields
					this.title = resp.title
					// this.width=resp.width
					//console.log(this.fields)
				})
			},
			feeSave() {
				this.feeShow = false
			},
			feeCanse() {
				this.feeShow = false
			},
			get_farm_invest() {
				getFarmInvest(this.$route.params.id, this.year).then(resp => {
					this.farm_reg_year = resp.farm_reg_year
					this.est_total = resp.est_total
					this.pieData1["subTitle"] = '总金额:' + resp.est_total + '万元'
					this.pieData1["pieEchartsData"] = resp.est_data

					this.fact_total = resp.fact_total
					this.pieData2["subTitle"] = '总金额:' + resp.fact_total + '万元'
					this.pieData2["pieEchartsData"] = resp.fact_data

					this.estimateWidth = resp.est_total * 100 / (resp.est_total + resp.fact_total)
					this.actualWidth = resp.fact_total * 100 / (resp.est_total + resp.fact_total)

					resp.est_data.forEach((item, index) => {
						if (index != 3) {
							this.columnarData1.xAxisData.push(item.name)
							this.columnarData1.estimateData.push(item.value)
						}
					})
					
					let number=0;
						let manage={};
						this.columnarData1.actualData=[]
					resp.fact_data.forEach((item, index) => {

                        if(index<2)
						 {
						this.columnarData1.actualData.push(item.value)
						}
					
						if((item.name=="肥料费用") || ( item.name=="农药费用")){
							  number=number+item.value;
						}else{
							if(index==4){
								 manage=item
							}else{
							this.fact_data.push(item)
							}
						}
						
					})
					this.fact_data.push(({label:"农资费用",value:number.toFixed(2)}))
				this.columnarData1.actualData.push(number)
				this.columnarData1.actualData.push(manage)
					this.fact_data.push(manage)
				
					this.show = true
				})

			},
			tabsClick(index) {
				this.tabShowNum = index
				this.show1 = false

				console.log(index)
				//总收入
				if (index == 1) {
					this.columnarData2["estimateData"] = []
					this.columnarData2["actualData"] = []
					getFarmIncome(this.$route.params.id, this.year).then(resp => {
						// this.columnarData2["estimateData"].push(resp.ygtotal)
						let series = []
							resp.list.forEach((item, index) => {

								series.push({
									name: item.crop.name,
									type: 'bar',
									barWidth: '80',
									stack: 'estimate',
									emphasis: {
										focus: 'series'
									},
									data: [item.yjtotal_price, item.sjtotal_price]
								}, )
								//item.
								this.columnarData2["actualData"]=series
							})

console.log(this.columnarData2)
						this.show1 = true
						this.income_list = resp.list
						this.total = resp.total

					})
				}
				//总利润
				if (index == 2) {
					this.show2 = false
					this.columnarData3["estimateData"] = []
					this.columnarData3["actualData"] = []
					this.columnarData4["xAxisData"] = []
					this.columnarData4["estimateData"] = []
					this.columnarData4["actualData"] = []

					getFarmProfit(this.$route.params.id, this.year).then(resp => {
						resp.forEach((item, index) => {
							if (item.year == this.year) {
								this.columnarData3["estimateData"].push(item.est_income)
								this.columnarData3["actualData"].push(item.fact_income)
								this.est_rate = item.est_rate
								this.fact_rate = item.fact_rate
							} else {
								this.columnarData4["xAxisData"].push(item.year + "年")
								this.columnarData4["estimateData"].push(item.est_income)
								this.columnarData4["actualData"].push(item.fact_income)
							}
						})
						this.show2 = true
						console.log(this.columnarData3)
					})

				}
			},
			handleSizeChange: function(size) {
				this.tabPage.pagesize = size;
				this.get_farm_fee_list()
				//console.log(this.pagesize)  //每页下拉显示数据
			},
			handleCurrentChange: function(currentPage) {
				this.tabPage.currentPage = currentPage;
				this.get_farm_fee_list()
				//console.log(this.currentPage)  //点击第几页
			},
			// 表格斑马纹
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 !== 1) {
					return 'single-row';
				} else {
					return 'double-row';
				}
			},

		},
		mounted() {

		},
		components: {
			wxPie,
			wxColumnar,
			WxMessageBox,
			Columnar,
			NewColumnar
		}
	}
</script>

<style lang="less">
	.benefit {
		.head {

			/*display: flex;*/
			/*justify-content: space-between;*/
			/*align-items: center;*/
			.tabs {
				display: flex;
				margin-top: 20px;

				span {
					width: 150px;
					height: 28px;
					border: 1px solid #2B92F6;
					line-height: 28px;
					font-size: 14px;
					color: #fff;
					text-align: center;
					cursor: pointer;
				}

				.active {
					background: #2B92F6;
					color: #fff;
				}
			}

			.select_year {
				margin-top: 25px;
				display: flex;
				align-items: center;

				.label {
					width: 80px;
					font-size: 16px;
					color: #91AFBA;
				}

				.el-date-editor {
					width: 125px;
				}

				.el-input__inner {
					width: 125px;
					text-align: center;
					font-size: 16px;
					background-color: transparent;
					border: 1px solid #5C7E9F;
					color: #91AFBA;
				}
			}
		}

		.wx_content {
			margin-top: 16px;

			.wx_box {
				.wx_main {
					background: radial-gradient(rgba(19, 62, 173, 0.74), rgba(5, 18, 32, 0.47));
					background-size: cover;

					.top {
						overflow: hidden;
						padding: 11px 30px 30px 17px;
					}

					.wx_progress {
						.item {
							font-size: 15px;
							font-weight: 400;
							color: #fff;
							line-height: 25px;
							padding-top: 22px;
							overflow: hidden;

							span {
								float: left;
							}

							.label {
								width: 100px;
								font-size: 15px;
								color: #91AFBA;
							}

							.val {
								padding-left: 13px;
							}

							.progress {
								width: 200px;
								display: inline-block;
								height: 20px;

								i {
									display: inline-block;
									height: 100%;
								}
							}

							.violet {
								background-color: #9966FF;
							}

							.pink {
								background-color: #FF99FF;
							}
						}
					}

					.wx_table {
						padding: 0 31px 0 26px;

						thead {
							tr {
								th {
									font-size: 16px;
								}
							}
						}

						tbody {
							tr {
								td {
									font-size: 16px;
								}
							}
						}
					}
				}
			}

			.echars_warp {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 30px;

				.pie {
					width: 1152px;
					min-height: 742px;

					.echarts_box {
						display: flex;
						justify-content: space-between;
						padding: 30px 50px 80px 0;
					}
				}

				.bar {
					width: 880px;
					min-height: 742px;

					.echarts_box {
						padding: 0 30px;
					}

					.bar_table {
						width: 100%;
						margin-bottom: 35px;

						tbody {
							tr {
								td {
									border: 1px solid #415179;
									color: #fff;
									font-size: 14px;
									text-align: center;
									padding: 14px 0;
									position: relative;

									span {
										font-size: 10px;
										color: #008CF7;
										cursor: pointer;
									}

									&:first-child:before {
										content: '';
										width: 14px;
										height: 14px;
										background: linear-gradient(180deg, #4C83FF 0%, #2AFADF 100%);
										position: absolute;
										left: 10px;
										top: 50%;
										margin-top: -7px;
									}
								}

								.actualTd {
									&:first-child:before {
										background: linear-gradient(360deg, #F4A7A1 0%, #FF3F5F 100%);
									}
								}
							}
						}

					}
				}
			}

			.tab_box {
				overflow: hidden;
				margin: auto;
				column-count: 2;
				-webkit-column-count: 2;
				-moz-column-count: 2;

				.top {
					display: flex;
					justify-content: space-between;

					.closse {
						width: 64px;
						height: 23px;
						line-height: 23px;
						border-radius: 2px;
						border: 1px solid #10FFCA;
						font-size: 14px;
						font-weight: 500;
						color: #10FFCA;
						text-align: center;
						cursor: pointer;
					}
				}

				.wx_box {
					break-inside: avoid;
					width: 920px;
					margin: 0 auto 30px auto;
					-moz-column-gap: 30px;
					-webkit-column-gap: 30px;
					column-gap: 30px;

					.wx_main {
						padding-bottom: 33px;
					}
				}

				.tab_item {
					display: flex;
					align-items: center;
					padding-top: 12px;

					.item {
						width: 275px;
						font-size: 16px;
						font-weight: 500;
						color: #C7D7DE;

						.label {
							padding-left: 40px;
						}

						.val {
							padding-left: 10px;
						}
					}
				}
			}

			.wx_bar {
				overflow: hidden;
				padding-bottom: 180px;

				.echarts_bar {
					width: 690px;
				}

				.tabs_bar {
					width: 864px;
					margin-left: 10%;

					.bar_table {
						border-collapse: separate;
						border-spacing: 1px;

						thead {
							tr {
								th {
									font-size: 16px;
									font-weight: 800;
									color: #fff;
									background-color: rgba(45, 153, 255, 0.9);
									text-align: center;
									padding: 5px 0;
								}
							}
						}

						tbody {
							tr {
								td {
									background: rgba(45, 153, 255, 0.14);
									border: 1px solid rgba(45, 153, 255, 0.48);
									font-size: 16px;
									font-weight: 500;
									color: #C7D7DE;
									padding: 6px 0;
									text-align: center;
								}
							}
						}
					}
				}

				.w536 {
					width: 536px;
					float: left;

					&+.w536 {
						margin-left: 50px;
					}
				}

				.w800 {
					width: 800px;
					float: left;

					&+.w536 {
						margin-left: 50px;
					}
				}
			}

		}
	}
</style>
